


import { Button, DatePicker, Input, message, Space } from 'antd';
import './index.less';
import { useEffect, useState, useRef } from 'react';
import { graphicStore } from '@/commons/store/graphic-store';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import locale from 'antd/es/date-picker/locale/zh_CN';
import { ModelBase } from '.yalc/pytha/dist';
import { createPrimitiveMulti } from '@/api/geometry/primitive';
import { useParams } from 'react-router-dom';

interface IProps {
    onClose: () => void
}

export default function EditDevicePanel(props: IProps) {
    const { projectUuid, modelUuid } = useParams();
    const [device, setDevice] = useState<any>({});

    const onValueChange = (value: any, field: string) => {
        device[field] = value;
        setDevice({ ...device });
    }

    const setting = () => {
        let editor = graphicStore?.extraContext?.getCurrentViewEditor();
        if (!editor) {
            props.onClose();
            return;
        }
        let par: any = {};
        if (!!device?.location) {
            par.location = device.location;
        }
        if (!!device?.model) {
            par.model = device.model;
        }
        if (!!device?.code) {
            par.code = device.code;
        }
        if (!!device?.deliveryTime) {
            par.deliveryTime = device.deliveryTime;
        }
        if (!!device?.expirationTime) {
            par.expirationTime = device.expirationTime;
        }
        if (!!device?.species) {
            par.species = device.species;
        }
        if (!!device?.temperature) {
            par.temperature = device.temperature;
        }
        if (!!device?.useTime) {
            par.useTime = device.useTime;
        }
        if (!!device?.manufacturer) {
            par.manufacturer = device.manufacturer;
        }
        if (!!device?.performance) {
            par.performance = device.performance;
        }
        // 获取所有选中的图元
        let selected: ModelBase[] = editor?.selectControl?.getSelectedEntityList() || [];
        let saveJsonList = [];
        selected?.forEach(item => {
            let entity = editor.entityDict[item.uuid];
            if (!entity?.extraData) {
                entity.extraData = {};
            }
            entity.extraData = {
                ...entity.extraData,
                ...par,
            }
            saveJsonList.push(entity.toJson());
        })

        editor.listeners.signals.emptySelectedEntities.dispatch();
        editor.listeners.signals.needRender.dispatch('redraw');

        createPrimitiveMulti(saveJsonList, { modelUuid: modelUuid, projectUuid: projectUuid }).then(res => {
            message.success("更新成功");
        }).catch((e) => {
            message.error("更新失败！")
        })

        props.onClose();
    }

    return (
        <div className='edit-device-container'>
            <div className=''>设备数据录入</div>
            <div className='info-row'>
                <div className='left'>位置</div>
                <div className='right'><Input size='small' value={device?.location} onChange={(e) => onValueChange(e.target.value, 'location')} /></div>
            </div>
            <div className='info-row'>
                <div className='left'>型号</div>
                <div className='right'><Input size='small' value={device?.model} onChange={(e) => onValueChange(e.target.value, 'model')} /></div>
            </div>
            <div className='info-row'>
                <div className='left'>编号</div>
                <div className='right'><Input size='small' value={device?.code} onChange={(e) => onValueChange(e.target.value, 'code')} /></div>
            </div>
            <div className='info-row'>
                <div className='left'>生产日期</div>
                <div className='right'>
                    <DatePicker
                        suffixIcon={null} allowClear={false} value={device?.deliveryTime ? dayjs(+device?.deliveryTime) : null}
                        placeholder="请选择" style={{ width: '100%' }} picker={'month'}
                        locale={locale} needConfirm={false} size='small'
                        onChange={(time) => {
                            onValueChange(time.valueOf(), 'deliveryTime')
                        }}
                    />
                </div>
            </div>
            <div className='info-row'>
                <div className='left'>过期日期</div>
                <div className='right'>
                    <DatePicker
                        suffixIcon={null} allowClear={false} value={device?.expirationTime ? dayjs(+device?.expirationTime) : null}
                        placeholder="请选择" style={{ width: '100%' }} picker={'month'}
                        locale={locale} needConfirm={false} size='small'
                        onChange={(time) => {
                            onValueChange(time.valueOf(), 'expirationTime')
                        }}
                    />
                </div>
            </div>
            <div className='info-row'>
                <div className='left'>种类</div>
                <div className='right'><Input size='small' value={device?.species} onChange={(e) => onValueChange(e.target.value, 'species')} /></div>
            </div>
            <div className='info-row'>
                <div className='left'>使用温度</div>
                <div className='right'><Input size='small' value={device?.temperature} onChange={(e) => onValueChange(e.target.value, 'temperature')} /></div>
            </div>
            <div className='info-row'>
                <div className='left'>喷射时间</div>
                <div className='right'><Input size='small' value={device?.useTime} onChange={(e) => onValueChange(e.target.value, 'useTime')} /></div>
            </div>
            <div className='info-row'>
                <div className='left'>制造商</div>
                <div className='right'><Input size='small' value={device?.manufacturer} onChange={(e) => onValueChange(e.target.value, 'manufacturer')} /></div>
            </div>
            <div className='info-row'>
                <div className='left'>性能参数</div>
                <div className='right'><Input size='small' value={device?.performance} onChange={(e) => onValueChange(e.target.value, 'performance')} /></div>
            </div>
            <Space>
                <Button type='primary' size='small' onClick={setting}>设置</Button>
                <Button size='small' onClick={() => {
                    props.onClose();
                }}>关闭</Button>
            </Space>
        </div>
    )
}